export default "__VITE_ASSET__akoNq491__"